var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "disabled": ""
    }
  }, [_c('b-card', {
    attrs: {
      "header": "Kontainer"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-kontainer",
      modifiers: {
        "modal-kontainer": true
      }
    }],
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Kontainer\n    ")]), _vm._v(" "), _c('modal-kontainer', {
    ref: "modalKontainer"
  }), _vm._v(" "), (this.$store.state.barpin.kontainer.length) ? _c('table', {
    staticClass: "table table-responsive table-sm table-striped mt-3"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Nomor Kontainer")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Ukuran Kontainer")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((this.$store.state.barpin.kontainer), function(item, index) {
    return _c('tr', {
      key: item.NO_KONTAINER
    }, [_c('td', [_vm._v(_vm._s(item.NO_KONTAINER))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(((item.UKURAN_KONTAINER) + " Feet / " + (item.JNS_KONTAINER))))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.removeKontainer(item.ID_KONTAINER)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  }))]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": "Kemasan"
    }
  }, [(this.$store.state.barpin.kemasan.length < 1) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-kemasan",
      modifiers: {
        "modal-kemasan": true
      }
    }],
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Kemasan\n    ")]) : _vm._e(), _vm._v(" "), (this.$store.state.barpin.kemasan.length) ? _c('table', {
    staticClass: "table table-responsive table-sm mt-3"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Jumlah Kemasan")]), _vm._v(" "), _c('th', [_vm._v("Jenis Kemasan")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((this.$store.state.barpin.kemasan), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.JML_KMS))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.JNS_KMS))]), _vm._v(" "), _c('td', [_c('button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-kemasan-edit",
        modifiers: {
          "modal-kemasan-edit": true
        }
      }],
      staticClass: "btn btn-secondary",
      on: {
        "click": function($event) {
          _vm.getDetilKemasan(item.ID_KEMASAN)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })])])])
  }))]) : _vm._e()], 1), _vm._v(" "), _c('modal-kemasan', {
    ref: "modalKemasan"
  }), _vm._v(" "), _c('modal-kemasan-edit', {
    ref: "modalKemasanEdit"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": "Barang"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-barang",
      modifiers: {
        "modal-barang": true
      }
    }],
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Barang\n    ")]), _vm._v(" "), (this.$store.state.barpin.barang.length) ? _c('table', {
    staticClass: "table table-responsive table-striped mt-3"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Nama Barang")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Jumlah Barang")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Nilai Barang")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((this.$store.state.barpin.barang), function(item, index) {
    return _c('tr', {
      key: item.URAIAN_BARANG
    }, [_c('td', [_vm._v(_vm._s(item.URAIAN_BARANG))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(((item.JML_SATUAN) + " " + (item.JNS_SATUAN) + " / " + (item.JML_KEMASAN) + " " + (item.JNS_KEMASAN) + " ")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.CIF.toLocaleString()))]), _vm._v(" "), _c('td', [_c('button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-edit-barang",
        modifiers: {
          "modal-edit-barang": true
        }
      }],
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.getDetilBarang(item.ID_BARANG)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.removeBarang(item.ID_BARANG)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  }))]) : _vm._e()], 1), _vm._v(" "), _c('modal-barang', {
    ref: "modalBarang"
  }), _vm._v(" "), _c('modal-edit-barang', {
    ref: "modalEditBarang"
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c98c130","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ppftz/Perekaman/Step-2.vue
// module id = 366
// module chunks = 0